import {
  SelectForm,
  Error,
  CancelButton,
  SubmitButton,
  InputForm,
} from "components";
import { CreateSpecialOfferInput, SpecialOfferInputError } from "modules/special_offer/state/actionType";
import { connect } from "react-redux";
import { PackageProps } from "modules/membership_plan/commercial_membership_plan/packages/store/actionType";
import { MembershipDurationsProps } from "modules/membership_plan/commercial_membership_plan/membership_duration/store/actionType";
import { fetchMembershipDurationByPackageId } from "modules/membership_plan/commercial_membership_plan/membership_duration/store/action";
import { fetchPackages } from "modules/membership_plan/commercial_membership_plan/packages/store/action";
import { useEffect } from "react";

interface FormProps {
  formData: CreateSpecialOfferInput;
  formError: SpecialOfferInputError;
  handleChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => void;
  handleSubmit: React.MouseEventHandler<HTMLButtonElement>;
  loading: boolean;
  header: string;
  onClose: () => void;
}

type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type StateProps = ReturnType<typeof mapStateToProps>;
type Props = DispatchProps & StateProps & FormProps;
const SpecialOfferForm: React.FC<Props> = ({
  onFetchMembershipDuration,
  fetchMembershipDurationByPackageId,
  onFetchPackages,
  fetchPackages,
  formData,
  formError,
  handleChange,
  handleSubmit,
  loading,
  header,
  onClose,
}) => {

  const formatDateForInput = (dateStr?: string) =>
  dateStr ? new Date(dateStr).toISOString().split("T")[0] : "";

  useEffect(() => {
    onFetchPackages();
    if (formData.package_id) {
      onFetchMembershipDuration(formData.package_id);
    }
  }, [formData.package_id, onFetchMembershipDuration, onFetchPackages]);

  return (
    <>
      <div className="px-4">
        <h2 className="w-full text-center font-bold text-2xl pb-4">{header}</h2>
        <form>
          <div className="grid grid-cols-2 gap-4">
            <div className="">
            <InputForm
              label="Title"
              type="text"
              id="title"
              name="title"
              value={formData.title}
              onChange={handleChange}
            />
            {formError?.title && <Error>{formError.title}</Error>}
          </div>
          <div className="">
            <InputForm
              label="Description"
              type="text"
              id="description"
              name="description"
              value={formData.description}
              onChange={handleChange}
            />
            {formError?.description && <Error>{formError.description}</Error>}
          </div>
          </div>
          <div className="">
            <SelectForm
              label="Packages"
              type="text"
              value={formData.package_id}
              id="package_id"
              name="package_id"
              option={fetchPackages?.packages?.map((pkg: PackageProps) => (
                <option key={pkg.id.toString()} value={pkg.id.toString()}>
                  {pkg.name}
                </option>
              ))}
              onChange={handleChange}
            />
            {formError?.packages_id && <Error>{formError.packages_id}</Error>}
          </div>
          <div className="">
            <SelectForm
              label="Membership Duration"
              type="text"
              value={formData.membership_duration_id}
              id="membership_duration_id"
              name="membership_duration_id"
              option={
              formData.package_id
                ? fetchMembershipDurationByPackageId?.membershipDuration?.map(
                    (item: MembershipDurationsProps) => (
                      <option
                        key={item.id.toString()}
                        value={item.id.toString()}
                      >
                        {item.duration_type}
                      </option>
                    )
                  )
                : []
            }
              onChange={handleChange}
            />
            {formError?.membership_duration_id && <Error>{formError.membership_duration_id}</Error>}
          </div>
          <div className="">
            <InputForm
              label="Start Date"
              type="date"
              id="start_date"
              name="start_date"
              value={formatDateForInput(formData.start_date)}
              onChange={handleChange}
            />
            {formError?.start_date && <Error>{formError.start_date}</Error>}
          </div>
          <div className="">
            <InputForm
              label="End Date"
              type="date"
              id="end_date"
              name="end_date"
              value={formatDateForInput(formData.end_date)}
              onChange={handleChange}
            />
            {formError?.end_date && <Error>{formError.end_date}</Error>}
          </div>
          <div className="">
            <InputForm
              label="Number of Days"
              type="number"
              id="number_of_days"
              name="number_of_days"
              value={formData.number_of_days}
              onChange={handleChange}
            />
            {formError?.number_of_days && <Error>{formError.number_of_days}</Error>}
          </div>
          <div className="w-full flex items-center justify-between px-5 mt-4">
            <CancelButton onClick={onClose} type="button" />
            <SubmitButton
              onClick={handleSubmit}
              loading={loading}
              loadingText="Uploading..."
              type="submit"
            />
          </div>
        </form>
      </div>
    </>
  );
};


const mapStateToProps = (state: any) => ({
  fetchPackages: state.packages?.fetchPackagesState,
  fetchMembershipDurationByPackageId:
    state.membershipDuration?.fetchmembershipDurationState,
});

const mapDispatchToProps = (dispatch: any) => ({
  onFetchPackages: () => dispatch(fetchPackages()),
  onFetchMembershipDuration: (package_id: string) =>
    dispatch(fetchMembershipDurationByPackageId(package_id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SpecialOfferForm);
